import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue')
  },
  {
    path: '/matches/:match',
    name: 'seats',
    component: () => import(/* webpackChunkName: "seats" */ '../views/SeatsView.vue'),
    props: route => ({
      match: route.params.match,
      seat: route.query.seat
    })
  },
  {
    path: '/matches',
    name: 'matches',
    component: () => import(/* webpackChunkName: "matches" */ '../views/MatchesView.vue')
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import(/* webpackChunkName: "notifications" */ '../views/NotificationsView.vue')
  },
  {
    path: '/users/new',
    component: () => import(/* webpackChunkName: "usernew" */ '../views/NewUserView.vue'),
    children: [
      { 
        path: '',
        name: 'users-new',
        component: () => import(/* webpackChunkName: "usernewform" */ '../views/NewUserFormView.vue'),
        meta: {
          step: 1
        }
      }, { 
        path: 'matches/:match',
        name: 'users-new-seats',
        component: () => import(/* webpackChunkName: "seats" */ '../views/SeatsView.vue'),
        props: route => ({
          match: route.params.match,
          userMode: true
        }),
        meta: {
          step: 2
        }
      }, { 
        path: 'matches',
        name: 'users-new-matches',
        component: () => import(/* webpackChunkName: "matches" */ '../views/MatchesView.vue'),
        props: {
          userMode: true
        },
        meta: {
          step: 2
        }
      }, { 
        path: 'confirm',
        name: 'users-new-confirm',
        component: () => import(/* webpackChunkName: "usernewconfirm" */ '../views/NewUserConfirmView.vue'),
        props: {
          userMode: true
        },
        meta: {
          step: 3
        }
      },
    ]
  },
  {
    path: '/users/:user',
    name: 'user',
    component: () => import(/* webpackChunkName: "user" */ '../views/UserView.vue'),
    props: true
  },
  {
    path: '/users',
    name: 'users',
    component: () => import(/* webpackChunkName: "users" */ '../views/UsersView.vue')
  },
  {
    path: '/club',
    name: 'club',
    component: () => import(/* webpackChunkName: "club" */ '../views/ClubView.vue')
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
